import { SET_HEADER_FOR_WEB_VIEW } from "../ActionTypes";

export const setHeaderForWebView = data => dispatch => {
    dispatch({
        type : SET_HEADER_FOR_WEB_VIEW,
        payload : data
    })
}